import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HomepagelocalService } from '../countryhome.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-video-section',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class VideoSectionComponent implements OnInit {
  @Input() pageData:any;
  constructor(private homePageService: HomepagelocalService) {}

  videoData: any;
  isPlaying: boolean = false;
  ngOnInit(): void {
    const data = this.pageData?.psProductVideo?.fields;
    if (data) {
      this.videoData = data;
    }
  }
  playVideo(videoPlayer: HTMLVideoElement) {
    videoPlayer.play();
    this.isPlaying = true;
  }

  onPlay() {
    this.isPlaying = true;
  }

  onPause() {
    this.isPlaying = false;
  }
}
